import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '../context/AuthContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setEmailSent(true);
      toast.success('Herstel e-pos is gestuur!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Kon nie versoek verwerk nie');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
        <div className="w-full max-w-lg text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-8">
            E-pos Gestuur
          </h1>
          <div className="bg-parchment border border-[#E5E0D6] p-8 md:p-12">
            <p className="font-body text-lg text-charcoal mb-4">
              Ons het 'n wagwoord herstel e-pos gestuur na:
            </p>
            <p className="font-body text-xl text-gold font-medium mb-6">
              {email}
            </p>
            <p className="font-body text-lg text-muted-charcoal mb-6">
              Kyk asseblief u inkassie (en spam vouer) vir die herstel skakel.
            </p>
            <p className="font-body text-sm text-muted-charcoal">
              Die skakel is geldig vir 1 uur.
            </p>
            <div className="mt-8">
              <Link 
                to="/login" 
                className="text-gold hover:underline font-ui text-sm uppercase tracking-widest"
              >
                Terug na Aanmeld
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12 flex items-center justify-center">
      <div className="w-full max-w-md">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-8 text-center">
          Wagwoord Vergeet
        </h1>

        <div className="bg-parchment border border-[#E5E0D6] p-8 md:p-12">
          <p className="font-body text-lg text-muted-charcoal mb-6">
            Voer u e-posadres in en ons sal vir u 'n herstel skakel e-pos.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block font-ui text-sm uppercase tracking-widest text-charcoal mb-2">
                E-pos
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-password-email"
                className="w-full bg-transparent border-b border-charcoal/20 focus:border-gold px-0 py-4 text-xl font-body placeholder:text-charcoal/40 outline-none transition-colors"
                placeholder="u.epos@voorbeeld.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-password-submit"
              className="w-full bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? 'Besig...' : 'Stuur Herstel E-pos'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <Link to="/login" data-testid="link-to-login" className="text-gold hover:underline font-body text-lg">
              Terug na Aanmeld
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
